import { Component, AfterViewInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './header/header';
import { Sidebar } from './sidebar/sidebar';
import { Footer } from './footer/footer';
import { SidebarStateService } from './shared/sidebar-state.service';

declare global {
  interface Window {
    KTComponents?: { init: () => void };
    KTLayout?: { init: () => void };
  }
}

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, Header, Sidebar, Footer],
  templateUrl: './layout.html',
  styleUrl: './layout.css',
})
export class Layout implements AfterViewInit {
  private readonly sidebarState = inject(SidebarStateService);

  protected readonly sidebarCollapsed = this.sidebarState.collapsed;

  ngAfterViewInit(): void {
    window.KTComponents?.init();
    window.KTLayout?.init();
  }

  protected onExpandSidebar(): void {
    this.sidebarState.expand();
  }
}
